import * as React from 'react';
import classnames from 'classnames';
import { Flyout } from '@grandvisionhq/common';
import { Icon } from '@grandvisionhq/icons';
import { useIntl } from '@grandvisionhq/state';
import { getConcatClickTrackingAttributes } from '@grandvisionhq/svc-tealium/utils';
import { getPersonalizedGreeting } from './get-personalized-greeting.js';
import Loader from './Loader.js';

const MyAccountMenu = ({ menuItems =[] , viewState , personalDetails , className ,  })=>{
    const { getFormattedLabel , getLabel  } = useIntl();
    const message = getPersonalizedGreeting({
        getLabel,
        getFormattedLabel,
        personalDetails
    });
    const tealiumAttributesAccount = {
        'data-element-id': `MainNav_Account`
    };
    const getClickTrackingAttributes = (item)=>{
        var ref;
        const link = (ref = item.link) === null || ref === void 0 ? void 0 : ref.href;
        if (link === null || link === void 0 ? void 0 : link.includes('my-account/login' )) {
            return {
                'data-element-id': `MainNav_Account_LoginRegister`
            };
        }
        return getConcatClickTrackingAttributes(item.label, tealiumAttributesAccount);
    };
    return /*#__PURE__*/ React.createElement(Flyout, {
        "data-t": "myaccount-menu",
        id: "myaccount-menu",
        className: classnames('myaccount-menu', className)
    }, /*#__PURE__*/ React.createElement(Flyout.Trigger, {
        "data-t": "my-account-menu-button",
        className: classnames('header-menu__icon myaccount-menu-button', className, 'myaccount-menu-button--link'),
        title: viewState === 'unknown-user' ? getLabel('account.menu.greeting.loggedOut') : message,
        "aria-controls": "myaccount-menu",
        tealiumAttributes: tealiumAttributesAccount
    }, viewState === 'unknown-user' && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Icon, {
        name: "user"
    }), /*#__PURE__*/ React.createElement("span", {
        "data-t": "logged-out-greeting",
        className: "myaccount-menu-button__label"
    }, getLabel('account.menu.greeting.loggedOut'))), viewState === 'known-user' && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Icon, {
        name: "user-checkmark"
    }), /*#__PURE__*/ React.createElement("span", {
        className: "myaccount-menu-button__label",
        "data-t": "personalized-greeting"
    }, message)), viewState === 'loading' && /*#__PURE__*/ React.createElement(Loader, null)), /*#__PURE__*/ React.createElement(Flyout.Menu, null, menuItems.map((item)=>{
        var ref, ref1, ref2;
         return React.createElement(Flyout.MenuItem, {
            key: item.label,
            link: (ref = item.link) === null || ref === void 0 ? void 0 : ref.href,
            action: (ref1 = item.parameters) === null || ref1 === void 0 ? void 0 : ref1.action,
            className: "myaccount-menu__item",
            tealiumAttributes: getClickTrackingAttributes(item)
        }, /*#__PURE__*/ React.createElement("span", {
            className: "myaccount-menu__icon"
        }, /*#__PURE__*/ React.createElement(Icon, {
            name: ((ref2 = item.parameters) === null || ref2 === void 0 ? void 0 : ref2.icon) || ''
        })), item.label);
    })));
};

export { MyAccountMenu };
//# sourceMappingURL=MyAccountMenu.js.map
